import { useState } from 'react';

import type { ProductDetailState } from 'reducers/detail/productDetail';
import { isProductDataLoaded } from 'helpers/ProductUtils';
import useMartyContext from 'hooks/useMartyContext';
import { PageLoader } from 'components/Loader';
import { Accordion } from 'components/common/Accordion';
import ExpandableProductDescription from 'components/productdetail/description/ExpandableProductDescription';

interface ItemInformationAccordionProps {
  product: ProductDetailState;
  productId: string;
}

export const ItemInformationAccordion = ({ product, productId }: ItemInformationAccordionProps) => {
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);

  const {
    marketplace: {
      features: { showReviews }
    }
  } = useMartyContext();

  if (!isProductDataLoaded(product, productId)) {
    return <PageLoader />;
  }

  const { detail } = product;

  if (!detail) {
    return null;
  }

  const { defaultProductType, description } = detail;

  return (
    <div data-test-id="itemInformationAccordion">
      <Accordion heading="Product Information">
        <div className="isolate w-full">
          <ExpandableProductDescription
            productId={productId}
            defaultProductType={defaultProductType}
            descriptionItems={description}
            allowCollapse={showReviews}
            isExpanded={isDescriptionExpanded}
            setIsExpanded={setIsDescriptionExpanded}
          />
        </div>
      </Accordion>
    </div>
  );
};
